import { ChevronDown, ChevronUp } from "lucide-react";
import React from "react";
import PropTypes from "prop-types";

import ImageWithFallback from "../../ImagewithFallback";

import { renderCardInformation } from "../../../../Utils/CommonFunctions";

export default function RenderCreditCardDropDown(props) {
  const { handleCardSelect = () => {}, showDropdown = false, cardDataToShow = {}, cards = [], dropdownRef = null, 
  handleCardClick = () => {} } = props;

  const stopDropdownEvent = (event) => {
    event.stopPropagation();
  };

  return (
    <div ref={dropdownRef} className="dropdownHeaderWrapper" onClick={handleCardClick}>
      <div className="headerDropdown">
        <ImageWithFallback
          src={cardDataToShow?.sub_variant?.logo || cardDataToShow?.sub_variant?.payment_network?.logo}
          alt={cardDataToShow?.sub_variant?.name}
          className="headerDropdownLogo"
        />
        <div className="headerText">{renderCardInformation(cardDataToShow, false)}</div>
      </div>

      {showDropdown ? <ChevronUp size={12} /> : <ChevronDown size={12} />}

      {showDropdown && (
        <div className="dropdownBody" onClick={stopDropdownEvent} onMouseDown={stopDropdownEvent}>
          {cards.map((card) => (
            <div
              key={card.id}
              className="cardInfo"
              role="button"
              tabIndex={0}
              onClick={(event) => handleCardSelect(card, event)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  handleCardSelect(card, event);
                }
              }}
            >
              {renderCardInformation(card)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

RenderCreditCardDropDown.propTypes = {
  handleCardSelect: PropTypes.func,
  showDropdown: PropTypes.bool,
  cardDataToShow: PropTypes.object,
  cards: PropTypes.array,
  dropdownRef: PropTypes.object,
  handleCardClick: PropTypes.func,
};
